import type { RouterContext, RouterDataContext } from '@atlassian/jira-router';

export function getCurrentURL(routerContext: RouterContext | RouterDataContext) {
	const searchParams = new URLSearchParams(routerContext.query ?? {});
	const url = new URL(`http://example.com${routerContext.match.url}/?${searchParams.toString()}`);
	return url.toString();
}
